import { useQuery } from '@apollo/client'
import { GET_NEW_PATH_ENROLLMENT } from './queries/getPathEnrollment'

export const useNewPathEnrollment = (
  id: number,
  offset: number,
  limit: number,
  options?: { skip?: boolean },
) => {
  const { data, loading, error, called, fetchMore } = useQuery(
    GET_NEW_PATH_ENROLLMENT,
    {
      variables: {
        id,
        offset,
        limit,
      },
      skip: options?.skip || !id || isNaN(id),
      errorPolicy: 'all',
    },
  )

  return { getNewPathEnrollment: fetchMore, data, loading, error, called }
}
